<template>
  <div>
    <b-card title="Summary Products" style="overflow-x: hidden;">
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="8"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0 px-0 px-sm-1"
          >
            <b-form-group>
              Start Date
              <flat-pickr v-model="from" class="form-control w-100" />
            </b-form-group>
            <div class="h1 d-flex align-items-center">-</div>
            <b-form-group>
              End Date
              <flat-pickr v-model="to" class="form-control w-100" />
            </b-form-group>

            <b-form-group class="ml-2">
              Status
              <v-select
                v-model="productStatusSummary"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="productStatusSummaryOpt"
                :clearable="false"
                class="per-page-selector d-inline-block w-100"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start justify-content-md-end mb-md-0"
          >
            <div class="summary-actions">
              <b-button
                variant="primary"
                class="mt-1 mb-1"
                @click="applyFilter"
              >
                Filter
              </b-button>
              <b-button
                variant="primary"
                class="mt-1 mb-1"
                @click="exportSummary"
              >
                Export Summary
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- Larger screen than mobile -->
      <div class="d-none d-md-flex">
        <b-table
          class="summary-products-table"
          responsive
          :items="itemsSummary"
          :fields="fieldsSummary"
          :busy="isBusySummary"
          :tbody-tr-class="summaryRowClass"
        >
          <template #cell(Category)="data">
            <b-button
              v-if="isSummaryCategoryClickable(data.item)"
              variant="link"
              class="summary-category-link p-0"
              @click="openSummaryQuickView(data.item)"
            >
              {{ data.value }}
            </b-button>
            <span v-else>{{ data.value }}</span>
          </template>
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner
                class="align-middle mr-1"
                variant="secondary"
              ></b-spinner>
              <strong class="text-secondary">Loading...</strong>
            </div>
          </template>
        </b-table>
      </div>

      <!-- Mobile screen -->
      <div class="d-flex d-md-none flex-column">
        <!-- Loading -->
        <div v-if="isBusySummary" class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
        <!-- Data -->
        <b-row
          v-for="(item, index) in itemsSummary"
          v-if="!isBusySummary"
          :key="item.KODE"
          class="mb-3 list-item"
        >
          <b-col
            cols="12"
            class="d-flex flex-wrap justify-content-end align-items-center mb-1"
            style="gap: 1rem;"
          >
            <b-button
              v-if="isSummaryCategoryClickable(item)"
              variant="link"
              class="summary-category-link p-0 flex-grow-1 truncate text-left"
              @click="openSummaryQuickView(item)"
            >
              {{ item.Category }}
            </b-button>
            <strong v-else class="flex-grow-1 truncate">{{
              item.Category
            }}</strong>
          </b-col>
          <b-col cols="12" class="d-flex flex-wrap">
            <div style="font-size: 0.75rem;">
              <p><strong>TOTAL:</strong> {{ item.Total_Product }}</p>
              <p><strong>PERCENTAGE:</strong> {{ item.Percentage }}</p>
              <p><strong>VIDEO:</strong> {{ item.Video }}</p>
              <p><strong>BENEFIT:</strong> {{ item.Benefit }}</p>
              <p><strong>VALUE PROP:</strong> {{ item.Value_Proposition }}</p>
              <p><strong>SPEC:</strong> {{ item.Specification }}</p>
              <p><strong>STP:</strong> {{ item.STP }}</p>
              <p><strong>CONFIG:</strong> {{ item.Konfigurasi }}</p>
              <p><strong>SLA/SLG:</strong> {{ item.SLA_SLG }}</p>
              <p><strong>FAQ:</strong> {{ item.FAQ }}</p>
              <p><strong>CASE STUDY:</strong> {{ item.Case_Study }}</p>
              <p><strong>BANNER:</strong> {{ item.Banner }}</p>
              <p><strong>PRODUCT BOOK:</strong> {{ item.Buku_Produk }}</p>
              <p>
                <strong>SOCIAL MATERIAL:</strong> {{ item.Materi_Sosialisasi }}
              </p>
              <p><strong>BOOKLET:</strong> {{ item.Booklet }}</p>
              <p><strong>FLYER:</strong> {{ item.Flyer }}</p>
              <p><strong>CONTACT:</strong> {{ item.Kontak }}</p>
              <p><strong>ND PRODUCT:</strong> {{ item.ND_Penetapan_Produk }}</p>
              <p><strong>PHOTO PRODUCT:</strong> {{ item.Photo }}</p>
              <p>
                <strong>SALES PROPOSITION:</strong> {{ item.Sales_Proposition }}
              </p>
              <p><strong>PROPOSAL:</strong> {{ item.Proposal }}</p>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card title="Products" style="overflow-x: hidden;">
      <div class="mx-0 my-2 mx-sm-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block ml-50 mr-1"
            />
            <b-button
              variant="primary"
              :to="{ name: 'admin-product-add' }"
              class="mr-1"
            >
              Create Product
            </b-button>
            <b-button
              variant="primary"
              @click="
                exportToExcel(
                  xlsData,
                  ['KODE', 'PRODUCT', 'PORTFOLIO', 'CFU', 'STATUS', 'DATE'],
                  ['kode', 'product', 'category', 'cfu', 'status', 'date'],
                  ['Product Catalog'],
                  formatJson
                )
              "
              >Export All</b-button
            >
          </b-col>

          <b-col sm="12" md="3" class="d-flex flex-row align-items-center">
            <span>Status</span>
            <v-select
              v-model="productStatus"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="productStatusOpt"
              :clearable="false"
              class="per-page-selector flex-grow-1 d-inline-block ml-50 mr-1"
            />
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="3"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <label class="mr-1">
              Search
            </label>
            <div
              class="d-flex flex-grow-1 align-items-center justify-content-end"
            >
              <b-form-input
                v-model="searchWord"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <!-- Larger screen than mobile -->
      <div class="d-none d-md-flex">
        <b-table
          responsive
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items="items"
          :fields="fields"
          :no-local-sorting="true"
          :busy="isBusy"
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner
                class="align-middle mr-1"
                variant="secondary"
              ></b-spinner>
              <strong class="text-secondary">Loading...</strong>
            </div>
          </template>
          <template #cell(action)="data">
            <div class="d-flex justify-content-start">
              <!-- <b-form-checkbox
                switch
                :checked="data.item.hiddenTarif"
                v-b-tooltip.hover.top="data.item.hiddenTarif ? 'Unhide Tarif' : 'Hidden Tarif'"
                @change="toggleTarif(data.item)"
              >
              </b-form-checkbox> -->
              <div class="d-flex justify-content-start">
                <b-button
                  v-b-tooltip.hover.top="'Tarif Document'"
                  variant="outline-primary"
                  size="sm"
                  class="btn-icon mr-1"
                  :disabled="loadingItem === data.item.KODE"
                  @click="openModal(data.item)"
                >
                  <!-- <feather-icon icon="PaperclipIcon" /> -->
                  <template v-if="loadingItem === data.item.KODE">
                    <b-spinner
                      small
                      type="border"
                      label="Loading..."
                    ></b-spinner>
                  </template>
                  <template v-else>
                    <feather-icon icon="PaperclipIcon" />
                  </template>
                </b-button>
              </div>
              <!-- Testimonial function, not part of D2P rundown, disabled for now -->
              <!-- <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'View Testimonials'"
                variant="outline-info"
                class="btn-icon mr-1"
                :disabled="loadingTestimonialItem === data.item.KODE"
                @click="openTestimonialModal(data.item)"
              >
                <b-spinner
                  v-if="loadingTestimonialItem === data.item.KODE"
                  small
                  type="border"
                  label="Loading..."
                ></b-spinner>
                <feather-icon v-else icon="MessageSquareIcon" />
              </b-button> -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'Edit Product'"
                variant="outline-warning"
                class="btn-icon mr-1"
                @click="
                  $router.push({
                    name: 'admin-product-edit',
                    params: { key: data.item.KODE },
                  })
                "
              >
                <feather-icon icon="Edit3Icon" />
              </b-button>
              <b-button
                v-if="isApprover"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'Approve Product'"
                variant="danger"
                class="btn-icon mr-1"
                @click="approval(data.item.KODE)"
              >
                <feather-icon icon="CheckIcon" />
              </b-button>
              <b-button
                v-if="isApprover"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'Archive Product'"
                variant="outline-warning"
                class="btn-icon mr-1"
                @click="archive(data.item.KODE)"
              >
                <feather-icon icon="ArchiveIcon" />
              </b-button>
              <b-button
                v-if="isApprover"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'Delete Product'"
                variant="danger"
                class="btn-icon mr-1"
                @click="showMsgBoxDelete(data.item)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
              <b-button
                v-if="isApprover"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'Retire Product'"
                variant="warning"
                class="btn-icon mr-1"
                @click="retire(data.item.KODE)"
              >
                <feather-icon icon="InboxIcon" />
              </b-button>
            </div>
          </template>
          <template #cell(PROD_CATEGORY)="data">
            {{
              data.item.product_category_details &&
              data.item.product_category_details.name
                ? data.item.product_category_details.name
                : '-'
            }}
          </template>
          <template #cell(cfu)="data">
            {{
              data.item.cfu_details && data.item.cfu_details.length > 0
                ? data.item.cfu_details.map(x => x.cfu_name).join(',')
                : '-'
            }}
          </template>
          <template #cell(publish)="data">
            <div>
              <b-form-checkbox
                v-if="data.item.APPROVED_BY"
                :checked="data.item.PROD_SHOW_STATUS == 1 ? 'true' : 'false'"
                class="custom-control-danger"
                name="check-button"
                switch
                @change="approval(data.item.KODE)"
              />
              <b-form-checkbox
                v-else
                v-b-tooltip.hover.top="'Need Approve First'"
                :disabled="data.item.APPROVED_BY == NULL"
                :checked="data.item.PROD_SHOW_STATUS == 1 ? 'true' : 'false'"
                class="custom-control-danger"
                name="check-button"
                switch
                style="cursor:auto !important"
                @change="approval(data.item.KODE)"
              />
            </div>
          </template>
          <template #cell(CREATED_DATE)="data">
            <div>{{ $moment(data.value).format('YYYY-MM-DD  ') }}</div>
          </template>
          <template #cell(PROD_SHOW_STATUS)="data">
            <b-badge
              v-if="!data.item.archived_at && data.value == 1"
              pill
              variant="success"
            >
              {{
                data.item.archived_at
                  ? 'Archived'
                  : data.value == 1
                  ? 'Publish'
                  : 'Unpublish'
              }}
            </b-badge>
            <b-badge v-if="data.item.archived_at || data.value == 0" pill>
              {{
                data.item.archived_at
                  ? 'Archived'
                  : data.value == 1
                  ? 'Publish'
                  : 'Unpublish'
              }}
            </b-badge>
            <b-badge v-if="data.item.RETIREMENT == 1" pill variant="warning">
              {{ data.item.RETIREMENT == 1 ? 'Retired' : '' }}
            </b-badge>
          </template>
        </b-table>
      </div>

      <b-modal
        id="tarif-modal"
        v-model="showModal"
        title="Edit Tarif"
        @ok="submitTarif"
      >
        <div class="d-flex align-items-center">
          <b-form-checkbox
            v-model="selectedTarif.hiddenTarif"
            v-b-tooltip.hover.top="
              selectedTarif.hiddenTarif ? 'Unhide Tarif' : 'Hidden Tarif'
            "
            switch
          >
          </b-form-checkbox>
          <b-form-textarea
            id="tarifDescription"
            v-model="selectedTarif.message"
            placeholder="Enter your message..."
            class="flex-grow-1"
            rows="3"
            max-rows="6"
          />
        </div>
      </b-modal>

      <!-- Mobile screen -->
      <div class="d-flex d-md-none flex-column">
        <!-- Loading -->
        <div v-if="isBusy" class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
        <!-- Data -->
        <b-row
          v-for="(item, index) in items"
          v-if="!isBusy"
          :key="item.KODE"
          class="mb-3 list-item"
        >
          <b-col
            cols="12"
            class="d-flex flex-wrap justify-content-end align-items-center mb-1"
            style="gap: 1rem;"
          >
            <strong class="flex-grow-1 truncate">{{ item.PRODUCT }}</strong>
            <div>
              <b-button
                v-b-tooltip.hover.top="'Tarif Document'"
                variant="outline-primary"
                size="sm"
                class="btn-icon mr-1"
                :disabled="loadingItem === item.KODE"
                @click="openModal(item)"
              >
                <!-- <feather-icon icon="PaperclipIcon" /> -->
                <template v-if="loadingItem === item.KODE">
                  <b-spinner small type="border" label="Loading..."></b-spinner>
                </template>
                <template v-else>
                  <feather-icon icon="PaperclipIcon" />
                </template>
              </b-button>
              <!-- Testimonial function, not part of D2P rundown, disabled for now -->
              <!-- <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'View Testimonials'"
                variant="outline-info"
                class="btn-icon mr-1"
                :disabled="loadingTestimonialItem === item.KODE"
                @click="openTestimonialModal(item)"
              >
                <b-spinner
                  v-if="loadingTestimonialItem === item.KODE"
                  small
                  type="border"
                  label="Loading..."
                ></b-spinner>
                <feather-icon v-else icon="MessageSquareIcon" />
              </b-button> -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'Edit Product'"
                variant="outline-warning"
                class="btn-icon mr-1"
                @click="
                  $router.push({
                    name: 'admin-product-edit',
                    params: { key: item.KODE },
                  })
                "
              >
                <feather-icon icon="Edit3Icon" />
              </b-button>
              <b-button
                v-if="isApprover"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'Approve Product'"
                variant="danger"
                class="btn-icon mr-1"
                @click="approval(item.KODE)"
              >
                <feather-icon icon="CheckIcon" />
              </b-button>
              <b-button
                v-if="isApprover"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'Archive Product'"
                variant="outline-warning"
                class="btn-icon mr-1"
                @click="archive(item.KODE)"
              >
                <feather-icon icon="ArchiveIcon" />
              </b-button>
              <b-button
                v-if="isApprover"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'Delete Product'"
                variant="danger"
                class="btn-icon mr-1"
                @click="showMsgBoxDelete(item)"
              >
                <feather-icon icon="Trash2Icon" />
              </b-button>
              <b-button
                v-if="isApprover"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                v-b-tooltip.hover.top="'Retire Product'"
                variant="warning"
                class="btn-icon mr-1"
                @click="retire(item.KODE)"
              >
                <feather-icon icon="InboxIcon" />
              </b-button>
            </div>
          </b-col>
          <b-col cols="12" class="d-flex flex-wrap">
            <div style="font-size: 0.75rem;">
              <p><strong>KODE:</strong> {{ item.KODE }}</p>
              <p>
                <strong>PORTFOLIO:</strong>
                {{
                  item.product_category_details &&
                  item.product_category_details.name
                    ? item.product_category_details.name
                    : '-'
                }}
              </p>
              <p>
                <strong>CFU:</strong>
                {{
                  item.cfu_details && item.cfu_details.length > 0
                    ? item.cfu_details.map(x => x.cfu_name).join(',')
                    : '-'
                }}
              </p>
              <p>
                <strong>STATUS: </strong>
                <b-badge
                  v-if="!item.archived_at && item.PROD_SHOW_STATUS == 1"
                  pill
                  variant="success"
                >
                  {{
                    item.archived_at
                      ? 'Archived'
                      : item.PROD_SHOW_STATUS == 1
                      ? 'Publish'
                      : 'Unpublish'
                  }}
                </b-badge>
                <b-badge
                  v-if="item.archived_at || item.PROD_SHOW_STATUS == 0"
                  pill
                >
                  {{
                    item.archived_at
                      ? 'Archived'
                      : item.PROD_SHOW_STATUS == 1
                      ? 'Publish'
                      : 'Unpublish'
                  }}
                </b-badge>
                <b-badge v-if="item.RETIREMENT == 1" pill variant="warning">
                  {{ item.RETIREMENT == 1 ? 'Retired' : '' }}
                </b-badge>
              </p>
              <p>
                <strong>CREATED AT:</strong>
                {{ $moment(item.CREATED_DATE).format('YYYY-MM-DD') }}
              </p>
              <template v-if="isApprover">
                <p>
                  <strong>PUBLISH:</strong>
                  <b-form-checkbox
                    v-if="item.APPROVED_BY"
                    :checked="item.PROD_SHOW_STATUS == 1 ? 'true' : 'false'"
                    class="custom-control-danger"
                    name="check-button"
                    switch
                    @change="approval(item.KODE)"
                  />
                  <b-form-checkbox
                    v-else
                    v-b-tooltip.hover.top="'Need Approve First'"
                    :disabled="item.APPROVED_BY == NULL"
                    :checked="item.PROD_SHOW_STATUS == 1 ? 'true' : 'false'"
                    class="custom-control-danger"
                    name="check-button"
                    switch
                    style="cursor:auto !important"
                    @change="approval(item.KODE)"
                  />
                </p>
              </template>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ currentPage * perPage - perPage + 1 }} to
              {{ currentPage * perPage - perPage + showData }} of
              {{ totalData }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalData"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="inputPagination"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
      id="summary-quickview-modal"
      v-model="showSummaryQuickViewModal"
      scrollable
      size="xl"
      ok-title="Close"
      cancel-variant="outline-secondary"
      :ok-only="true"
      centered
      header-bg-variant="danger"
      header-text-variant="light"
      modal-class="quickview-modal"
      :title="`Quick View — ${selectedSummaryCategory}`"
    >
      <!-- Info bar -->
      <div class="quickview-info-bar mb-2">
        <span class="text-muted small">
          Showing products that still have incomplete data
        </span>
        <div v-if="!isBusySummaryQuickView" class="quickview-badges">
          <b-badge variant="secondary" class="mr-1">
            Total: {{ summaryQuickViewCategoryTotal }}
          </b-badge>
          <b-badge variant="danger">
            Incomplete: {{ summaryQuickViewItems.length }}
          </b-badge>
        </div>
      </div>

      <!-- Loading -->
      <div v-if="isBusySummaryQuickView" class="text-center py-4">
        <b-spinner variant="danger" />
        <div class="text-muted small mt-1">Memuat data...</div>
      </div>

      <!-- Empty -->
      <div
        v-else-if="summaryQuickViewItems.length === 0"
        class="text-center py-4 text-muted"
      >
        <feather-icon icon="CheckCircleIcon" size="36" class="text-success mb-1" />
        <div v-if="summaryQuickViewCategoryTotal === 0">
          Tidak ada produk pada kategori ini sesuai filter aktif.
        </div>
        <div v-else>
          Semua <strong>{{ summaryQuickViewCategoryTotal }}</strong> produk sudah lengkap.
        </div>
      </div>

      <!-- Table + Pagination -->
      <template v-else>
        <!-- Larger screen than mobile -->
        <div class="d-none d-md-block">
          <b-table
            responsive
            bordered
            hover
            small
            :items="summaryQuickViewPaginatedItems"
            :fields="summaryQuickViewFields"
            thead-class="quickview-table-head"
          >
            <template #cell(no)="data">
              <span class="text-muted">
                {{ (quickViewCurrentPage - 1) * quickViewPerPage + data.index + 1 }}
              </span>
            </template>
            <template #cell(PRODUCT)="data">
              <span class="font-weight-bold">{{ data.value }}</span>
            </template>
            <template #cell(missing_count)="data">
              <b-badge
                :variant="
                  data.value >= 15
                    ? 'danger'
                    : data.value >= 8
                    ? 'warning'
                    : 'info'
                "
              >
                {{ data.value }}
              </b-badge>
            </template>
            <template #cell(field_statuses)="data">
              <div class="quickview-badge-list">
                <span
                  v-for="field in data.value"
                  :key="field.label"
                  :class="['quickview-field-badge', field.filled ? 'qf-filled' : 'qf-missing',]"
                  v-b-tooltip.hover.top
                  :title="field.filled ? `✔ ${field.label}` : `✘ ${field.label}`"
                >
                  {{ field.label }}
                </span>
              </div>
            </template>
            <template #cell(action)="data">
              <b-button
                size="sm"
                variant="flat-primary"
                class="btn-icon"
                v-b-tooltip.hover.left
                title="View Product"
                @click="
                  $router.push({
                    name: 'admin-product-edit',
                    params: { key: data.item.KODE },
                  })
                "
              >
                <feather-icon icon="EyeIcon" size="15" />
              </b-button>
            </template>
          </b-table>
        </div>

        <!-- Mobile screen -->
        <div class="d-flex d-md-none flex-column">
          <b-row
            v-for="(item, index) in summaryQuickViewPaginatedItems"
            :key="item.KODE"
            class="mb-3 list-item"
          >
            <b-col
              cols="12"
              class="d-flex flex-wrap justify-content-end align-items-center mb-1"
              style="gap: 1rem;"
            >
              <strong class="flex-grow-1 truncate">
                {{ (quickViewCurrentPage - 1) * quickViewPerPage + index + 1 }}.
                {{ item.PRODUCT }}
              </strong>
              <b-button
                size="sm"
                variant="flat-primary"
                class="btn-icon"
                @click="
                  $router.push({
                    name: 'admin-product-edit',
                    params: { key: item.KODE },
                  })
                "
              >
                <feather-icon icon="EyeIcon" size="15" />
              </b-button>
            </b-col>
            <b-col cols="12" class="d-flex flex-wrap">
              <div style="font-size: 0.75rem;" class="w-100">
                <p class="mb-1">
                  <strong>MISSING:</strong>
                  <b-badge
                    :variant="
                      item.missing_count >= 15
                        ? 'danger'
                        : item.missing_count >= 8
                        ? 'warning'
                        : 'info'
                    "
                  >
                    {{ item.missing_count }}
                  </b-badge>
                </p>
                <div class="quickview-badge-list">
                  <span
                    v-for="field in item.field_statuses"
                    :key="field.label"
                    :class="[
                      'quickview-field-badge',
                      field.filled ? 'qf-filled' : 'qf-missing',
                    ]"
                  >
                    {{ field.label }}
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- Pagination -->
        <div class="quickview-pagination-wrap">
          <small class="text-muted">
            Showing
            {{ (quickViewCurrentPage - 1) * quickViewPerPage + 1 }}–{{
              Math.min(quickViewCurrentPage * quickViewPerPage, summaryQuickViewItems.length)
            }}
            from {{ summaryQuickViewItems.length }} product
          </small>
          <b-pagination
            v-model="quickViewCurrentPage"
            :total-rows="summaryQuickViewItems.length"
            :per-page="quickViewPerPage"
            size="sm"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          />
        </div>
      </template>
    </b-modal>
    <b-modal
      id="image-review"
      scrollable
      title="Image Review"
      ok-title="Close"
      centered
      cancel-variant="outline-secondary"
      :ok-only="true"
      size="md"
    >
      <b-card-text>
        <b-row class="justify-content-center">
          <b-col md="8" sm="4">
            <b-img thumbnail fluid rounded :src="imgSelectedItem"> </b-img>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <!-- Testimonial function, not part of D2P rundown, disabled for now -->
    <!-- <b-modal
      id="testimonial-view-modal"
      v-model="showTestimonialModal"
      scrollable
      size="lg"
      ok-title="Close"
      cancel-variant="outline-secondary"
      :ok-only="true"
      centered
      header-bg-variant="info"
      header-text-variant="light"
      :title="`Testimonials — ${testimonialModalProductName}`"
    >
      <div v-if="isBusyTestimonialModal" class="text-center py-4">
        <b-spinner variant="info" />
        <div class="text-muted small mt-1">Memuat testimonial...</div>
      </div>

      <div
        v-else-if="!testimonialModalItems.length"
        class="text-center text-muted py-4"
      >
        <feather-icon icon="MessageSquareIcon" size="24" class="mb-1" />
        <div>Belum ada testimonial untuk produk ini.</div>
      </div>

      <div v-else class="testimonial-modal-list">
        <div
          v-for="(item, index) in testimonialModalItems"
          :key="item.id || index"
          class="testimonial-modal-item"
        >
          <div class="testimonial-modal-item__avatar">{{ item.initial }}</div>
          <div class="testimonial-modal-item__body">
            <div
              class="d-flex justify-content-between align-items-start flex-wrap"
              style="gap: 0.5rem;"
            >
              <div>
                <strong>{{ item.name }}</strong>
                <div class="text-muted small">
                  {{ item.position || '-' }} · {{ item.division || '-' }}
                </div>
              </div>
              <div class="text-right">
                <div>
                  <span
                    v-for="star in 5"
                    :key="`tm-star-${index}-${star}`"
                    :class="[
                      'testimonial-modal-star',
                      star <= Number(item.rate || 0) ? 'is-active' : '',
                    ]"
                    >★</span
                  >
                </div>
                <small class="text-muted">{{ item.createdAtLabel }}</small>
              </div>
            </div>
            <p class="testimonial-modal-item__message">{{ item.message }}</p>
          </div>
        </div>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BSpinner,
  BFormCheckbox,
  BModal,
  BImg,
  VBTooltip,
  BFormTextarea,
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { generateToken } from '@/auth/helperAuth'
import dummyData from './dummy'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
    BFormCheckbox,
    BModal,
    BImg,
    BFormTextarea,
    vSelect,
    flatPickr,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    const yearNow = new Date().getFullYear()
    return {
      xlsData: [],
      token: '',
      perPage: '10',
      perPageOptions: ['10', '20', '30'],
      productStatus: '',
      productStatusOpt: ['publish', 'unpublish', 'archived', 'retired'],
      from: '2000-01-01',
      to: `${yearNow}-12-31`,
      productStatusSummary: null,
      productStatusSummaryOpt: [
        { label: 'All', value: 'all' },
        { label: 'Publish', value: 'publish' },
        { label: 'Unpublish', value: 'unpublish' },
        { label: 'Archived', value: 'archived' },
        { label: 'Retired', value: 'retired' },
      ],
      currentPage: 1,
      totalData: 200,
      showData: 0,
      items: [],
      sortBy: 'CREATED_DATE',
      sortDesc: true,
      searchWord: '',
      isBusy: false,
      isHidden: false,
      showModal: false,
      loadingItem: null,
      // hiddenTarif: false,
      selectedTarif: {
        hiddenTarif: false,
        message: '',
      },
      selectedItem: {
        icon: '',
        icon_details: {},
      },
      loadingTestimonialItem: null,
      showTestimonialModal: false,
      isBusyTestimonialModal: false,
      testimonialModalProductName: '',
      testimonialModalItems: [],
      itemsSummary: [],
      isBusySummary: false,
      showSummaryQuickViewModal: false,
      selectedSummaryCategory: '',
      summaryQuickViewItems: [],
      summaryQuickViewCategoryTotal: 0,
      isBusySummaryQuickView: false,
      quickViewCurrentPage: 1,
      quickViewPerPage: 10,
      summaryQuickViewFields: [
        { key: 'no', label: 'No', thStyle: { width: '44px' }, tdClass: 'text-center align-middle' },
        { key: 'PRODUCT', label: 'Nama Produk', thStyle: { minWidth: '160px' }, tdClass: 'align-middle' },
        { key: 'missing_count', label: 'Incomplete Items', thStyle: { width: '80px' }, tdClass: 'text-center align-middle' },
        { key: 'field_statuses', label: 'Status Field' },
        { key: 'action', label: '', thStyle: { width: '64px' }, tdClass: 'text-center align-middle' },
      ],
      fieldsSummary: [
        { key: 'Category', label: 'Portfolio', sortable: true },
        { key: 'Total_Product', label: 'Total Product', sortable: true },
        { key: 'Percentage', label: 'Percentage', sortable: true },
        { key: 'Video', label: 'Video', sortable: true },
        { key: 'Benefit', label: 'Benefit', sortable: true },
        { key: 'Value_Proposition', label: 'Value Prop', sortable: true },
        { key: 'Specification', label: 'Spec', sortable: true },
        { key: 'STP', label: 'STP', sortable: true },
        { key: 'Konfigurasi', label: 'Config', sortable: true },
        { key: 'SLA_SLG', label: 'SLA/SLG', sortable: true },
        { key: 'FAQ', label: 'FAQ', sortable: true },
        { key: 'Case_Study', label: 'Case Study', sortable: true },
        { key: 'Banner', label: 'Banner', sortable: true },
        { key: 'Buku_Produk', label: 'Product Book', sortable: true },
        { key: 'Materi_Sosialisasi', label: 'Social Material', sortable: true },
        { key: 'Booklet', label: 'Booklet', sortable: true },
        { key: 'Flyer', label: 'Flyer', sortable: true },
        { key: 'Kontak', label: 'Contact', sortable: true },
        { key: 'ND_Penetapan_Produk', label: 'ND Product', sortable: true },
        { key: 'Photo', label: 'Photo Product', sortable: true },
        { key: 'Deskripsi', label: 'Deskripsi', sortable: true },
        {
          key: 'Sales_Proposition',
          label: 'Sales Proposition',
          sortable: true,
        },
        { key: 'Proposal', label: 'Proposal', sortable: true },
      ],
    }
  },
  computed: {
    labelTarif() {
      return this.isHidden ? 'Unhide Tarif' : 'Hidden Tarif'
    },
    summaryQuickViewPaginatedItems() {
      const start = (this.quickViewCurrentPage - 1) * this.quickViewPerPage
      return this.summaryQuickViewItems.slice(start, start + this.quickViewPerPage)
    },
    skip() {
      return this.perPage * (this.currentPage - 1)
    },
    imgSelectedItem() {
      return typeof this.selectedItem.icon_details === 'object' &&
        typeof this.selectedItem.icon_details.original === 'object'
        ? this.selectedItem.icon_details.original.url
        : ''
    },
    isApprover() {
      const { permissions } = this.$store.getters['oauth/getActiveUser']
      if (!permissions.includes('approve_product')) {
        return false
      }
      return true
    },
    fields() {
      let toShow = [
        { key: 'KODE', label: 'kode', sortable: true },
        { key: 'PRODUCT', label: 'product', sortable: true },
        { key: 'PROD_CATEGORY', label: 'portfolio' },
        'cfu',
        { key: 'PROD_SHOW_STATUS', label: 'status' },
        'publish',
        'action',
        { key: 'CREATED_DATE', label: 'created at', sortable: true },
      ]

      if (!this.isApprover) {
        toShow = toShow.filter(e => e !== 'publish')
      }
      return toShow
    },
  },
  watch: {
    perPage() {
      this.getProduct()
    },
    currentPage() {
      this.getProduct()
    },
    searchWord() {
      this.$store.dispatch('app/search', {
        callback: () => {
          this.getProduct()
        },
      })
    },
    productStatus() {
      this.getProduct()
    },
  },
  mounted() {
    this.getProduct()
    this.fetchXls()
    this.applyFilter()
  },

  created() {
    const payload = {
      client: 'product-catalog-fe',
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    }
    this.token = generateToken(payload)
  },

  methods: {
    isSummaryCategoryClickable(item) {
      if (!item) return false
      const category = String(item.Category || '')
        .trim()
        .toLowerCase()
      if (!category) return false
      return !['total', 'percentage', 'percentase', 'persentase'].includes(
        category
      )
    },
    normalizeCategoryName(category) {
      const normalized = String(category || '')
        .trim()
        .toLowerCase()
      if (!normalized) return ''
      if (normalized === '1' || normalized.includes('communication'))
        return 'communication'
      if (normalized === '2' || normalized.includes('datacomm'))
        return 'datacomm'
      if (normalized === '3' || normalized.includes('internet'))
        return 'internet'
      if (normalized === '4' || normalized.includes('wireless'))
        return 'wireless'
      if (normalized === '5' || normalized.includes('cyber'))
        return 'cyber security'
      return normalized
    },
    resolveProductCategory(product = {}) {
      const raw =
        product?.product_category_details?.name ||
        product?.PROD_CATEGORY ||
        product?.prod_category ||
        product?.CATEGORY ||
        product?.category ||
        ''
      return this.normalizeCategoryName(raw)
    },
    isFilledValue(value) {
      if (value === null || value === undefined) return false
      if (Array.isArray(value)) return value.length > 0
      if (typeof value === 'object') {
        return Object.keys(value).length > 0
      }
      if (typeof value === 'string') {
        const trimmed = value.trim()
        if (!trimmed) return false
        if (['-', 'null', 'undefined', '[]', '{}'].includes(trimmed))
          return false
        try {
          const parsed = JSON.parse(trimmed)
          if (Array.isArray(parsed)) return parsed.length > 0
          if (parsed && typeof parsed === 'object')
            return Object.keys(parsed).length > 0
        } catch (error) {
          return true
        }
        return true
      }
      return Boolean(value)
    },
    detectMissingFields(product = {}) {
      const requiredFields = [
        { label: 'Video', keys: ['videoLink', 'video', 'VIDEO'] },
        { label: 'Benefit', keys: ['PROD_BENEFIT', 'prod_benefit', 'benefit'] },
        {
          label: 'Value Prop',
          keys: ['VALUE_PROPOSITION', 'value_proposition'],
        },
        { label: 'Spec', keys: ['PROD_FEATURES', 'prod_features'] },
        { label: 'STP', keys: ['PROD_CUST_STP', 'prod_cust_stp'] },
        { label: 'Config', keys: ['PROD_CONFIG', 'prod_config'] },
        { label: 'SLA/SLG', keys: ['PROD_SLA_SLG', 'prod_sla_slg'] },
        { label: 'FAQ', keys: ['faq', 'FAQ', 'faq_details'] },
        { label: 'Case Study', keys: ['case_study', 'CASE_STUDY'] },
        { label: 'Banner', keys: ['banner_web', 'bannersLink', 'banner'] },
        { label: 'Product Book', keys: ['buku_produk', 'Buku_Produk'] },
        {
          label: 'Social Material',
          keys: ['materi_sosialisasi', 'Materi_Sosialisasi'],
        },
        { label: 'Booklet', keys: ['booklet', 'Booklet'] },
        { label: 'Flyer', keys: ['flyer', 'Flyer'] },
        { label: 'Contact', keys: ['contacts', 'kontak', 'Kontak'] },
        {
          label: 'ND Product',
          keys: ['nd_penetapan_produk', 'ND_Penetapan_Produk'],
        },
        {
          label: 'Photo Product',
          keys: ['photo_product', 'photoProductLink', 'Photo'],
        },
        {
          label: 'Sales Proposition',
          keys: ['SALES_PROPOSITION', 'sales_proposition'],
        },
        { label: 'Proposal', keys: ['proposal_product', 'Proposal'] },
      ]

      return requiredFields
        .filter(field => {
          const hasValue = field.keys.some(key =>
            this.isFilledValue(product[key])
          )
          return !hasValue
        })
        .map(field => field.label)
    },
    passesSummaryStatusFilter(product = {}) {
      const status = this.productStatusSummary?.value || 'all'
      if (status === 'all') return true

      const isArchived = Boolean(product.archived_at)
      const isRetired = Number(product.RETIREMENT) === 1
      const isPublished = Number(product.PROD_SHOW_STATUS) === 1

      if (status === 'archived') return isArchived
      if (status === 'retired') return isRetired
      if (status === 'publish') return !isArchived && !isRetired && isPublished
      if (status === 'unpublish')
        return !isArchived && !isRetired && !isPublished
      return true
    },
    passesSummaryDateFilter(product = {}) {
      const createdAt =
        product.CREATED_DATE || product.created_at || product.createdAt || null
      if (!createdAt) return false

      const createdDate = new Date(createdAt)
      if (Number.isNaN(createdDate.getTime())) return false

      const parseInputDate = (value, endOfDay = false) => {
        if (!value) return null
        if (value instanceof Date) {
          const normalized = new Date(value)
          if (Number.isNaN(normalized.getTime())) return null
          normalized.setHours(
            endOfDay ? 23 : 0,
            endOfDay ? 59 : 0,
            endOfDay ? 59 : 0,
            endOfDay ? 999 : 0
          )
          return normalized
        }
        const text = String(value).trim()
        if (!text) return null
        const hasTime = text.includes('T') || text.includes(' ')
        const normalizedText = hasTime
          ? text
          : `${text}T${endOfDay ? '23:59:59' : '00:00:00'}`
        const parsed = new Date(normalizedText)
        return Number.isNaN(parsed.getTime()) ? null : parsed
      }

      const startDate = parseInputDate(this.from, false)
      const endDate = parseInputDate(this.to, true)

      if (startDate && createdDate < startDate) return false
      if (endDate && createdDate > endDate) return false
      return true
    },
    getCategoryKeyFromName(categoryName) {
      const normalized = this.normalizeCategoryName(categoryName)
      const map = {
        communication: 'communication',
        datacomm: 'datacomm',
        internet: 'internet',
        wireless: 'wireless',
        'cyber security': 'cyber_security',
      }
      return map[normalized] || normalized.replace(/\s+/g, '_')
    },
    getFieldStatusesFromReport(item) {
      const fieldMap = [
        { key: 'Video', label: 'Video' },
        { key: 'Benefit', label: 'Benefit' },
        { key: 'Value_Proposition', label: 'Value Prop' },
        { key: 'Specification', label: 'Spec' },
        { key: 'STP', label: 'STP' },
        { key: 'Konfigurasi', label: 'Config' },
        { key: 'SLA_SLG', label: 'SLA/SLG' },
        { key: 'FAQ', label: 'FAQ' },
        { key: 'Case_Study', label: 'Case Study' },
        { key: 'Banner', label: 'Banner' },
        { key: 'Sales_Proposition', label: 'Sales Prop' },
        { key: 'Photo', label: 'Photo' },
        { key: 'Proposal', label: 'Proposal' },
        { key: 'Buku_Produk', label: 'Buku Produk' },
        { key: 'Materi_Sosialisasi', label: 'Materi Sos.' },
        { key: 'Booklet', label: 'Booklet' },
        { key: 'Flyer', label: 'Flyer' },
        { key: 'Kontak', label: 'Kontak' },
        { key: 'ND_Penetapan_Produk', label: 'ND Produk' },
      ]
      return fieldMap.map(f => ({
        label: f.label,
        filled: String(item[f.key] || '').includes('✔'),
      }))
    },
    async openSummaryQuickView(item) {
      if (!this.isSummaryCategoryClickable(item)) return

      this.selectedSummaryCategory = String(item.Category || '').trim()
      this.showSummaryQuickViewModal = true
      this.isBusySummaryQuickView = true
      this.summaryQuickViewItems = []
      this.summaryQuickViewCategoryTotal = 0
      this.quickViewCurrentPage = 1

      try {
        const yearNow = new Date().getFullYear()
        const status = this.productStatusSummary?.value || 'all'
        const startDate = this.from || '2000-01-01'
        const endDate = this.to || `${yearNow}-12-31`

        const response = await this.$http.get(
          `${process.env.VUE_APP_API_HELPER_URL}/dashboard/productCatalog/report`,
          {
            params: {
              type: 'details',
              status,
              startCreatedDate: startDate,
              endCreatedDate: endDate,
            },
            headers: {
              accept: 'application/json',
              Authorization: this.token,
            },
          }
        )

        const categoryKey = this.getCategoryKeyFromName(this.selectedSummaryCategory)
        const categoryProducts = response.data?.[categoryKey] || []
        this.summaryQuickViewCategoryTotal = categoryProducts.length

        this.summaryQuickViewItems = categoryProducts
          .map(product => {
            const fieldStatuses = this.getFieldStatusesFromReport(product)
            const missingCount = fieldStatuses.filter(f => !f.filled).length
            return {
              KODE: product.Kode,
              PRODUCT: product.Product,
              field_statuses: fieldStatuses,
              missing_count: missingCount,
            }
          })
          .filter(p => p.missing_count > 0)
          .sort((a, b) => b.missing_count - a.missing_count)
      } catch (error) {
        console.error('Quick view error:', error)
        this.$bvToast.toast('Gagal memuat quick view summary products', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.isBusySummaryQuickView = false
      }
    },
    summaryRowClass(item, type) {
      if (type !== 'row' || !item) return ''
      const category = String(item.Category || '')
        .trim()
        .toLowerCase()
      if (category === 'total') return 'summary-total-row'
      if (['percentage', 'percentase', 'persentase'].includes(category)) {
        return 'summary-percent-row'
      }
      return ''
    },
    async openModal(item) {
      const refName = `tarifTooltipRef-${item.KODE}`
      if (this.$refs[refName]) {
        this.$root.$emit('bv::hide::tooltip', this.$refs[refName])
      }
      this.loadingItem = item.KODE
      try {
        const resHidden = await this.$http.get(
          `${process.env.VUE_APP_API_HELPER_URL}/product/tarif/hidden`,
          {
            params: { product_kode: item.KODE },
            headers: {
              accept: 'application/json',
              Authorization: this.token,
            },
          }
        )
        this.selectedTarif.hiddenTarif =
          resHidden?.data?.data?.is_hidden ?? false
        this.selectedTarif.message = resHidden?.data?.data?.description
        this.selectedTarif.kode = item.KODE
        this.selectedItem = { ...item }
        this.showModal = true
      } catch (error) {
        console.error('Gagal memuat data:', error)
      } finally {
        this.loadingItem = null
      }
    },
    getTestimonialInitial(value = '') {
      const cleaned = String(value || '').trim()
      if (!cleaned) return 'NA'
      const parts = cleaned.split(/\s+/).filter(Boolean)
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
      return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase()
    },
    normalizeTestimonialItem(item = {}) {
      const userDetails = item.user_details || {}
      const name =
        userDetails.NAME ||
        userDetails.USERNAME ||
        userDetails.EMAIL_ADDRESS ||
        'Unknown User'
      return {
        id: item.id,
        initial: this.getTestimonialInitial(name),
        name,
        position: userDetails.JABATAN || '-',
        division: userDetails.DIVISION || '-',
        message: String(item.message || '').trim(),
        rate: Number(item.rating || 0),
        createdAtLabel: item.created_at
          ? this.$moment(item.created_at).format('DD MMM YYYY, HH:mm')
          : '-',
      }
    },
    async openTestimonialModal(item) {
      this.loadingTestimonialItem = item.KODE
      this.testimonialModalProductName = item.PRODUCT
      this.testimonialModalItems = []
      this.isBusyTestimonialModal = true
      this.showTestimonialModal = true
      try {
        const mapRequest = { map: { testimonials: 'd' } }
        const res = await this.$http.post(
          `/product/browse/id/${item.KODE}/set/first`,
          mapRequest
        )
        const records = res?.data?.data?.records || {}
        const testimonials = Array.isArray(records.testimonials)
          ? records.testimonials
          : []
        this.testimonialModalItems = testimonials.map(t =>
          this.normalizeTestimonialItem(t)
        )
      } catch (error) {
        console.error('Gagal memuat testimonial:', error)
        this.$bvToast.toast('Gagal memuat testimonial produk', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      } finally {
        this.isBusyTestimonialModal = false
        this.loadingTestimonialItem = null
      }
    },
    async submitTarif() {
      try {
        const response = await this.$http.put(
          `${process.env.VUE_APP_API_HELPER_URL}/product/tarif/hidden`,
          {
            is_hidden: this.selectedTarif.hiddenTarif,
            product_kode: this.selectedItem.KODE,
            description: this.selectedTarif.message,
          },
          {
            headers: {
              accept: 'application/json',
              Authorization: `${this.token}`,
            },
          }
        )
        if (response.status === 200) {
          this.$bvToast.toast('Document Tarif status updated successfully', {
            title: 'Success',
            variant: 'success',
            solid: true,
          })
          this.selectedTarif.message = ''
        }
      } catch (err) {
        this.$bvToast.toast(
          'Failed, to update document tarif status. try again later',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
          }
        )
      }
      this.showModal = false
    },
    async getProduct() {
      const searchWord = this.searchWord.trim()
      const base = '/product/browse/with.total/true'
      const take = `/take/${this.perPage}`
      const skip = `/skip/${this.skip}`
      const search = `${searchWord !== '' ? `/s/${searchWord}` : ''}`
      const status = `${
        this.productStatus !== '' ? `/status/${this.productStatus}` : ''
      }`
      const orderBy = `/orderBy.${this.sortBy}/${
        this.sortDesc === true ? 'desc' : 'asc'
      }`
      const complete = base + take + skip + search + status + orderBy
      this.isBusy = true
      const mapRequest = {
        map: {
          KODE: 's',
          PRODUCT: 's',
          PROD_CATEGORY: 's',
          PROD_SHOW_STATUS: 'i',
          CREATED_DATE: 'd',
          product_category_details: 'd',
          cfu_details: 'd',
          archived_at: 'd',
          RETIREMENT: 'i',
          APPROVED_BY: 'd',
        },
      }
      try {
        const res = await this.$http.post(complete, mapRequest)
        const products = res.data.data.records
        this.totalData = res.data.data.total
        this.showData = res.data.data.show

        // const updatedProducts = await Promise.all(products.map(async (item) => {
        //   try {
        //     const resHidden = await this.$http.get(
        //       `${process.env.VUE_APP_API_HELPER_URL}/product/tarif/hidden`,
        //       { params: { product_kode: item.KODE } }
        //     )
        //     const isHidden = resHidden?.data?.data?.is_hidden ?? false
        //     return { ...item, hiddenTarif: isHidden }
        //   } catch (e) {
        //     console.warn(`Failed to get product ${item.KODE}`, e)
        //     return { ...item, hiddenTarif: false }
        //   }
        // }))

        this.items = products
      } catch (err) {
        console.error(err)
      } finally {
        this.isBusy = false
      }
    },
    async toggleTarif(product) {
      try {
        const response = await this.$http.put(
          `${process.env.VUE_APP_API_HELPER_URL}/product/tarif/hidden`,
          { product_kode: product.KODE },
          {
            headers: {
              accept: 'application/json',
              Authorization: `${this.token}`,
            },
          }
        )

        this.$bvToast.toast('Document Tarif status updated successfully', {
          title: 'Success',
          variant: 'success',
          solid: true,
        })

        product.hiddenTarif = !product.hiddenTarif
      } catch (err) {
        this.$bvToast.toast(
          'Failed, to update document tarif status. try again later',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
          }
        )
      }
    },
    async fetchXls() {
      return this.$http
        .get('/product/take/all')
        .then(res => {
          this.xlsData = res.data.data.records || []
        })
        .catch(err => {
          console.error(err)
          this.xlsData = []
        })
    },
    dummyHttpGetProduct() {
      return new Promise(function(resolve, reject) {
        const res = {
          data: dummyData,
        }
        resolve(res)
      })
    },
    async deleteProduct(item) {
      this.isBusy = true
      return await this.$http
        .delete(`/product/${item.KODE}`)
        .then(res => {
          this.$notif(
            'Success',
            'Product has been successfully deleted.',
            'success'
          )
        })
        .catch(err => {
          let message = ''
          if (typeof err.data.errors === 'object') {
            message = err.data.errors[Object.keys(err.data.errors)[0]][0]
          } else if (typeof err.data.exception === 'object') {
            message = err.data.exception.message
          }
          this.$notif('Something Error', message, 'danger')
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    inputPagination(page) {
      this.currentPage = page
    },
    sortingChanged({ sortBy, sortDesc }) {
      // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
      // ctx.sortDesc ==> true if sorting descending, false otherwise
      if (sortBy !== '') {
        this.sortBy = sortBy
        this.sortDesc = sortDesc
        this.getProduct()
      }
    },
    async toggleActive(item) {
      const payload = {}
      if (item.active === 'Y') {
        payload.active = 'N'
      } else {
        payload.active = 'Y'
      }
      this.isBusy = true
      return await this.$http
        .post(`/category/${item.id}`, payload)
        .then(res => {
          this.getProduct()
        })
        .catch(err => {
          this.isBusy = false
        })
    },
    showMsgBoxDelete(item) {
      this.$bvModal
        .msgBoxConfirm('Please confirm that you want to delete this item.', {
          title: 'Please Confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          value === true &&
            this.deleteProduct(item).then(() => this.getProduct())
        })
    },
    async approval(kode) {
      return await this.$http
        .put(`/product/approval/${kode}`)
        .then(res => {
          this.$notif('Success', '', 'success')
          this.getProduct()
        })
        .catch(err => {
          let message = ''
          if (typeof err.data.errors === 'object') {
            message = err.data.errors[Object.keys(err.data.errors)[0]][0]
          } else if (typeof err.data.exception === 'object') {
            message = err.data.exception.message
          }
          this.$notif('Something Error', message, 'danger')
        })
    },
    async retire(kode) {
      return await this.$http
        .put(`/product/retirement/${kode}`)
        .then(res => {
          this.$notif('Success', '', 'success')
          this.getProduct()
        })
        .catch(err => {
          let message = ''
          if (typeof err.data.errors === 'object') {
            message = err.data.errors[Object.keys(err.data.errors)[0]][0]
          } else if (typeof err.data.exception === 'object') {
            message = err.data.exception.message
          }
          this.$notif('Something Error', message, 'danger')
        })
    },
    async archive(kode) {
      return await this.$http
        .put(`/product/archive/${kode}`)
        .then(res => {
          this.$notif('Success', '', 'success')
          this.getProduct()
        })
        .catch(err => {
          let message = ''
          if (typeof err.data.errors === 'object') {
            message = err.data.errors[Object.keys(err.data.errors)[0]][0]
          } else if (typeof err.data.exception === 'object') {
            message = err.data.exception.message
          }
          this.$notif('Something Error', message, 'danger')
        })
    },

    exportToExcel(records, headers, fieldVal, filename, formatJson) {
      if (this.xlsData.length == 0) {
        this.$notif('Please wait', 'Still getting all product data', 'danger')
      } else {
        import('@/libs/Export2Excel').then(excel => {
          const list = records
          const data = formatJson(fieldVal, list)
          excel.export_json_to_excel({
            header: headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx',
          })
        })
      }
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          let data = null
          data = v[j]

          if (j === 'kode') {
            data = v.KODE
          }

          if (j === 'product') {
            data = v.PRODUCT
          }

          if (j === 'category') {
            data = v.product_category_details
              ? v.product_category_details.name
              : ''
          }

          if (j === 'cfu') {
            data =
              v.cfu_details.length > 0
                ? v.cfu_details.map(cfu => cfu.cfu_name).toString()
                : ''
          }

          if (j === 'status') {
            console.log(v.archived_at !== null || v.PROD_SHOW_STATUS == 0)
            let a = ''
            let b = ''
            let c = ''
            if (v.archived_at == null && v.PROD_SHOW_STATUS == 1) {
              a =
                v.archived_at !== null
                  ? ' Archived'
                  : v.PROD_SHOW_STATUS == 1
                  ? ' Publish'
                  : ' Unpublish'
            }
            if (
              v.archived_at !== null ||
              v.PROD_SHOW_STATUS == 0 ||
              v.PROD_SHOW_STATUS == null
            ) {
              b =
                v.archived_at !== null
                  ? ' Archived'
                  : v.PROD_SHOW_STATUS == 1
                  ? ' Publish'
                  : ' Unpublish'
            }
            if (v.RETIREMENT == 1) {
              c = v.RETIREMENT == 1 ? ' Retired' : ''
            }
            data = a + b + c
          }

          if (j === 'date') {
            data = v.CREATED_DATE
          }

          return data
        })
      )
    },
    async applyFilter() {
      try {
        this.isBusySummary = true

        const yearNow = new Date().getFullYear()
        const defaultStart = `2000-01-01`
        const defaultEnd = `${yearNow}-12-31`

        const status = this.productStatusSummary?.value || 'all'
        const startDate = this.from || defaultStart
        const endDate = this.to || defaultEnd

        const response = await this.$http.get(
          `${process.env.VUE_APP_API_HELPER_URL}/dashboard/productCatalog/report`,
          {
            params: {
              type: 'summary',
              status,
              startCreatedDate: startDate,
              endCreatedDate: endDate,
            },
            headers: {
              accept: 'application/json',
              Authorization: this.token,
            },
          }
        )
        this.itemsSummary = response.data
      } catch (error) {
        console.error('API Error:', error)
      } finally {
        this.isBusySummary = false
      }
    },
    async exportSummary() {
      try {
        this.isBusySummary = true

        const yearNow = new Date().getFullYear()
        const defaultStart = '2000-01-01'
        const defaultEnd = `${yearNow}-12-31`

        const status = this.productStatusSummary?.value || 'all'
        const startDate = this.from || defaultStart
        const endDate = this.to || defaultEnd

        const response = await this.$http.get(
          `${process.env.VUE_APP_API_HELPER_URL}/dashboard/productCatalog/report/exportFile`,
          {
            params: {
              status,
              startCreatedDate: startDate,
              endCreatedDate: endDate,
            },
            headers: {
              accept: 'application/json',
              Authorization: this.token,
            },
            responseType: 'blob',
          }
        )

        const blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel',
        })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `summary_export_${startDate}_to_${endDate}.xlsx`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } catch (error) {
        console.error('Export Error:', error)
      } finally {
        this.isBusySummary = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style>
.modal-header {
  background-color: red !important;
}
.modal-title {
  color: white !important;
  font-weight: 600;
}
.table-row-selected {
  background-color: #f7d5d5 !important;
  cursor: pointer;
}
.pointer-row {
  cursor: pointer;
}

.summary-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: flex-start;
  width: 100%;
}

.summary-category-link {
  color: #d64344 !important;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-style: dashed;
  text-underline-offset: 2px;
}

.summary-category-link:hover {
  color: #b12525 !important;
}

@media (min-width: 768px) {
  .summary-actions {
    justify-content: flex-end;
    width: auto;
  }
}

/* Summary Products table: make Total vs Percentage readable */
.summary-products-table th,
.summary-products-table td {
  vertical-align: middle;
  white-space: nowrap;
}

/* Sticky first column (Category) when horizontal scrolling */
.summary-products-table thead th:first-child {
  position: sticky;
  left: 0;
  z-index: 5;
  background: #f3f2f7;
  box-shadow: 2px 0 0 #e5e7eb;
}

.summary-products-table tbody td:first-child {
  position: sticky;
  left: 0;
  z-index: 4;
  background: #fff;
  box-shadow: 2px 0 0 #e5e7eb;
}

.summary-products-table tbody tr.summary-total-row td:first-child {
  background: #fff7ed;
}

.summary-products-table tbody tr.summary-percent-row td:first-child {
  background: #eff6ff;
}

.summary-products-table th:not(:first-child),
.summary-products-table td:not(:first-child) {
  text-align: center;
}

/* Visual divider after PERCENTAGE column (3rd column). */
.summary-products-table th:nth-child(3),
.summary-products-table td:nth-child(3) {
  border-right: 2px solid #e5e7eb;
}

.summary-products-table tbody td:nth-child(3) {
  font-weight: 700;
}

.summary-products-table tbody tr.summary-total-row td {
  background: #fff7ed;
  font-weight: 700;
  border-top: 3px solid #cbd5e1;
}

.summary-products-table tbody tr.summary-percent-row td {
  background: #eff6ff;
  font-weight: 600;
  border-top: 1px dashed #94a3b8;
}

/* Quick View Modal */
#summary-quickview-modal .modal-header .close {
  color: #000 !important;
  text-shadow: none;
  opacity: 0.85;
}
#summary-quickview-modal .modal-header .close:hover {
  opacity: 1;
}

#testimonial-view-modal .modal-header .close {
  color: #fff !important;
  text-shadow: none;
  opacity: 0.85;
}
#testimonial-view-modal .modal-header .close:hover {
  opacity: 1;
}

.testimonial-modal-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.testimonial-modal-item {
  display: flex;
  gap: 0.85rem;
  padding: 0.9rem 1rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  background: #fff;
}

.testimonial-modal-item__avatar {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #cffafe, #a5f3fc);
  color: #0e7490;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.85rem;
}

.testimonial-modal-item__body {
  flex: 1;
  min-width: 0;
}

.testimonial-modal-item__message {
  margin: 0.5rem 0 0;
  font-size: 0.85rem;
  color: #334155;
  line-height: 1.55;
}

.testimonial-modal-star {
  color: #d1d5db;
  font-size: 15px;
  margin-right: 1px;
}

.testimonial-modal-star.is-active {
  color: #f59e0b;
}

/* Keep header & footer visible on short / mobile screens by capping the
   dialog to the viewport and letting the body scroll internally. */
.quickview-modal .modal-dialog {
  max-height: calc(100vh - 1rem);
  margin-top: auto;
  margin-bottom: auto;
}
.quickview-modal .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.quickview-modal .modal-body {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 991.98px) {
  .quickview-modal {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .quickview-modal .modal-dialog {
    max-width: 100%;
    max-height: calc(100vh - 2rem);
  }
  .quickview-modal .modal-content {
    max-height: calc(100vh - 2rem);
  }
}

.quickview-info-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.quickview-badges {
  display: flex;
  align-items: center;
}

.quickview-table-head th {
  background-color: #f3f4f6 !important;
  font-size: 0.76rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  white-space: nowrap;
}

.quickview-badge-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.quickview-field-badge {
  display: inline-block;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.18em 0.45em;
  border-radius: 4px;
  white-space: nowrap;
}

.qf-filled {
  background-color: #dcfce7;
  color: #15803d;
}

.qf-missing {
  background-color: #fee2e2;
  color: #b91c1c;
}

.quickview-pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e9ecef;
}
</style>
